<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00004"><span class="calibre1" id="Page_35" title="35"></span> <span>Afternoon Session</span></h2>
<p class="pindent">THE PRESIDENT: Are there any of the other defendants’ counsel
who wish to ask questions of this witness?</p>
<p class="pindent">DR. ALFRED SEIDL (Counsel for Defendants Hess and Frank):
Witness, can you recall what Hitler said in the Cabinet meeting,
regarding his political aims and the program of the new Government?</p>
<p class="pindent">LAMMERS: Hitler delivered a very long speech, in the course of
which the individual ministers also had a chance to speak. One of
the details I remember particularly is that the Führer talked, first
of all, about the removal of unemployment, something which would
definitely have to be achieved. Secondly, he spoke about the fact
that an economic revival of Germany would have to be provided for.
And thirdly, he talked in detail about the fact that a revision of the
Versailles Treaty would have to be effected, and that we would have
to try to put an end to the defamation of Germany which was contained
in the Versailles Treaty, and that one would have to strive
to achieve equality of rights for the German Reich within the circle
of nations.</p>
<p class="pindent">All these statements of Hitler’s were then written down in a
special Government declaration. I also recollect that in that Government
declaration the protection of positive Christianity was mentioned
in particular. I cannot recall the special details. But these,
I am convinced, are the main points concerned.</p>
<p class="pindent">Nothing was discussed which would have required special secrecy.
And what was discussed was, in the main, contained in the Government
declaration which was published in the press.</p>
<p class="pindent">DR. SEIDL: Did Hitler say anything at all, during this Cabinet
meeting, about the fact that he was going to alter the system of
government and that he wanted to govern dictatorially?</p>
<p class="pindent">LAMMERS: Herr Hitler expressed his opinion to the effect that
the present parliamentary system, prevailing up to that time in Germany,
had been a failure.</p>
<p class="pindent">THE PRESIDENT: You are speaking about a meeting. What was
the date of the meeting you are referring to?</p>
<p class="pindent">LAMMERS: It was the first Cabinet meeting which the Defense
Counsel inquired about. It took place on 30 January 1933, on the
day after the seizure of power. The Führer stated that the present
governmental system had been a failure. Furthermore he said that
the result of that failure had been that the Reich President was
obliged, in a state of emergency, according to Article 48 of the
Weimar Constitution, to govern by means of emergency decrees, and
that the only possibility was to create a stable Reich Government,
<span id="Page_36" title="36"></span>
a government which would be in power for many years. And
further, how one could create such a government would be something
which would have to be agreed upon first with the Reich
President and the Reichstag.</p>
<p class="pindent">DR. SEIDL: Witness, did Hitler say, during this Cabinet meeting,
that he wanted to concede to the NSDAP a specially favored position
of power?</p>
<p class="pindent">LAMMERS: He said that the NSDAP, as the strongest party,
would naturally have to have due influence in the German Government.
He said nothing to the effect that he wanted to put an end
to the other parties that still existed and were still represented in
the Cabinet, the German Nationalists and the Stahlhelm group.</p>
<p class="pindent">DR. SEIDL: Witness, did Hitler explain his foreign political aims
during this first meeting and did he say, in particular, that Germany
would definitely have to be freed from the shackles of the Versailles
Treaty and would again have to take the place befitting her in the
community of nations?</p>
<p class="pindent">LAMMERS: I answered that question already in the affirmative
before. Those were the foreign political aims, the complete revision
of the Versailles Treaty.</p>
<p class="pindent">DR. SEIDL: Did Hitler also mention at the time that for the
achievement of these foreign political aims one would have to run
the risk of another war, possibly even of a preventive war?</p>
<p class="pindent">LAMMERS: As far as I know and as far as I remember, no
mention was made of war, certainly not of a preventive war or an
aggressive war.</p>
<p class="pindent">DR. SEIDL: Witness, did Hitler, in the period following, in Cabinet
sessions or during any other meetings of all or numerous ministers,
present a comprehensive plan for the achievement of his foreign
political aims?</p>
<p class="pindent">LAMMERS: No, I knew of no comprehensive plan except the
general points I have mentioned. Neither during that meeting nor
during later meetings did Hitler elaborate a general plan. In my
opinion, he never did discuss and describe in detail any comprehensive
plans of a long-term character at all.</p>
<p class="pindent">DR. SEIDL: Witness, what caused Hitler a) to appoint Hess Deputy
to the Führer of the NSDAP and b) to make him a Reich minister?</p>
<p class="pindent">LAMMERS: He appointed Hess Deputy to the Führer, I believe,
because he, as Chancellor of the Reich, no longer wanted to attend
to the business of the Party and had to have a responsible man for
the technical leadership of the Party.
<span id="Page_37" title="37"></span></p>
<p class="pindent">He appointed Hess Reich Minister in order to create a link between
Party and State; to have a man in the Cabinet who was in a
position to represent the wishes and views of the Party in the
Cabinet. Perhaps he was thereby hoping to create a united front
between Party and State, something which became a law later on.</p>
<p class="pindent">DR. SEIDL: Witness, were the leading generals, a) before and
b) after seizure of power, in contact with the Reich directorate and
the Political Leadership Corps of the Party?</p>
<p class="pindent">LAMMERS: Before the seizure of power, as far as I know, contact
between the Party and the generals did not exist as such. There
could only have been cases of personal contact between individual
members of the Party and individual generals.</p>
<p class="pindent">After the seizure of power I had the opportunity of being present
when the Führer, at the beginning of February 1933, had the high-ranking
generals, the commanders-in-chief, introduced to him, and
I had the impression that the Führer did not know most of these
men, for they were all introduced to him—I stood nearby—and it
was my impression that he had known only a few of these men
previously.</p>
<p class="pindent">After the seizure of power, of course, the relations between the
Party leaders and the high-ranking generals became closer—after
the Party had gained a strong position in the State. But what I
would like to say is that relations, general relations, between the
Party, that is to say between the Reich directorate of the Party and
the Political Leadership Corps of the Party on the one side, and the
high-ranking generals and perhaps also the generals with lower
rank, on the other side—that these relations never went beyond the
purely formal, beyond so-called social relations which were based
on duty requirements at chance meetings, on festive occasions and
public demonstrations, <span class="it1">et cetera</span>. I feel that the general relations
between the Reich Directorate and the Political Leadership Corps of
the Party on the one side, and the generals on the other, were in no
instance any closer than that.</p>
<p class="pindent">DR. SEIDL: Witness, did the character of these relations change
after Hitler became the Head of the State and Supreme Commander
of the Armed Forces?</p>
<p class="pindent">LAMMERS: As far as the high-ranking generals are concerned,
I am of the opinion that in principle nothing changed, for the high-ranking
generals regarded the Führer not as the leader of the Party
but as the Head of the State, and they considered him the Supreme
Commander of the Armed Forces. Consequently, they did not believe
that they had to establish any particularly close relations with the
Party.
<span id="Page_38" title="38"></span></p>
<p class="pindent">DR. SEIDL: Witness, did joint meetings and conferences take
place for the discussion of political aims between the Reich Government,
the Reich Directorate of the Party, and the high-ranking
generals?</p>
<p class="pindent">LAMMERS: Such joint meetings or conferences are out of the
question. They never took place. That would also have been impossible
because of the large number of people involved.</p>
<p class="pindent">DR. SEIDL: Witness, were members of the Reich Government,
the Reich Directorate of the Party and the high-ranking generals
in a position to present their views to Hitler with regard to important
questions involving the welfare of the nation, particularly
on questions which concerned war or peace?</p>
<p class="pindent">LAMMERS: Jointly, these three groups, if I may say so, naturally
could not voice an opinion at all, for they had no connection with
each other in any way. But neither could any of these groups—the
Reich Directorate of the Party, the Reich Government, and the
generals—voice its opinion, in the first place because they were not
informed at all about the Führer’s political and economic aims.
What attitude could they take? They were simply taken by surprise
by the actual execution, by the accomplished facts, and any subsequent
voicing of an opinion would have meant a “stab in the back”
of the Führer’s policy.</p>
<p class="pindent">DR. SEIDL: Witness, then a general political plan on Hitler’s part—in
which these most important groups were active participants—did
not exist at all, and therefore there could be no talk of a conspiracy?</p>
<p class="pindent">LAMMERS: I know of no such general plan, but I can assure you
of one thing, that the large majority, the large majority of ministers
never knew anything of any such general plan. Just how far the
Führer informed individual persons of such plan, I do not know. I
was not present on such occasions. The Führer may have discussed
some sort of plans with one person or another, perhaps with a
member of the Party of the Reich Directorate or the generals; but
just what was discussed on such occasions I do not know. And of
course I cannot say whether in such cases these gentlemen agreed
or disagreed with the Führer. I also do not know whether shortly
before the execution of any large-scale political plans, such as for
instance the march into Czechoslovakia or something like that,
whether, shortly before, they could still advise the Führer as to
whether they agreed or were opposed, or whether they merely received
an order which they had to execute.</p>
<p class="pindent">DR. SEIDL: Witness, if I understand you correctly, then you
obviously want to say that all decisions of any magnitude were
made by Hitler alone?
<span id="Page_39" title="39"></span></p>
<p class="pindent">LAMMERS: The large-scale political decisions were certainly
made by him alone, at most with some few persons being consulted
and participating, but never with the Reich Government participating,
for the Reich Government—if I may go into detail about this—it
was when we left the League of Nations that Hitler for the
last time informed the Reich Government before taking an action.
Then followed as a large, important action, the march into the
Rhineland.</p>
<p class="pindent">The Cabinet was informed that we were going to withdraw from
the League of Nations; it was still informed beforehand.</p>
<p class="pindent">No one was informed of the march into the Rhineland; the Führer
informed the Reich Cabinet only after the march had taken place. On
the occasions of the march into Austria, the march into the Sudetenland,
the march into Prague, the outbreak of the Polish war, the
beginning of the other campaigns against Norway, France, Russia,
and so forth, the Reich Government were consulted by the Führer
neither beforehand, nor were they informed subsequently; and consequently
there were certain ill-feelings among all the ministers
because they were in no instance informed in advance of these
large-scale plans which had certain implications for the non-military
departments as well, and because the Reich Government did not
learn until later of the accomplished facts.</p>
<p class="pindent">Thus, to this extent I can say that all these decisions were made
by the Führer alone; and to what extent he consulted persons individually
I do not know. However, on the whole, the large majority
of the ministers were not informed of all these actions; they just
had general information such as any newspaper reader and any
radio listener has; or they, as I for instance, sometimes heard of such
a matter a few hours before, when it was made known to the press.
There was no questioning of the Führer or any information from
him beforehand.</p>
<p class="pindent">DR. SEIDL: Please tell me now just how it actually came about,
that the entire governmental power was thus transferred to the
Führer?</p>
<p class="pindent">LAMMERS: That transfer was accomplished, I might say, by
way of a gradually developing state customary law.</p>
<p class="pindent">DR. SEIDL: Slowly, please.</p>
<p class="pindent">LAMMERS: First of all, the Führer and the Reich Government
had been given, by the well-known Enabling Act of the Reichstag,
the power to alter the Constitution. The Reich Government made
use of this power in their actual legislation and, of course, use was
also made of it by way of passive endurance and by creating a state
customary law as was actually recognized in all countries. Thus in
the course of the first years, and also during the later years, it came
<span id="Page_40" title="40"></span>
about quite naturally by way of a state customary law, that the
Führer acted more independently than would actually have been
possible according to the Weimar Constitution. From the beginning
important political questions were all removed by the Führer from
the jurisdiction of the Cabinet.</p>
<p class="pindent">Even in 1933 and 1934, when Hindenburg was still alive, the
Führer did not wish general political questions to be raised in the
Cabinet by any minister. I repeatedly had to have various ministers
informed that they were to refrain from bringing up questions
which did not directly affect their department for discussion in the
Cabinet.</p>
<p class="pindent">For instance, I had to pass on such information to those gentlemen
who wanted to discuss church policy. I had been forbidden to
put any general political questions on the agenda of a Cabinet
meeting. If, in spite of that, a minister raised a political question
during a meeting of the Cabinet, then the Führer generally interposed
and silenced the minister concerned, or referred him to a
private discussion. Things developed in this way in the course of
time.</p>
<p class="pindent">After Von Hindenburg’s death, when the Führer became the
Head of State, such debates in the Cabinet were stopped altogether.
Nothing of this sort could be debated any more. The ministers were
not allowed to feel that they were political ministers. I had to inform
various gentlemen repeatedly, by order of the Führer, that they
were requested to refrain from voicing their opinions in regard to
such questions during Cabinet meetings.</p>
<p class="pindent">Then came the time, which I have already described, during
which the larger-scale actions took place and there were no more
Cabinet meetings. In this connection the Führer acted alone, and all
declarations which were made on behalf of the Reich Government
were made by him alone, acting on his own and without previous
consultation with the Cabinet. I must admit that the Cabinet very
often complained about that but could not prevail against the Führer.</p>
<p class="pindent">Thus gradually the governmental power—if I interpret “Regierung”
according to the conception of “government” laid down in
Anglo-Saxon law—then after 1936 there was no longer any complete
Reich Government at all consisting of the Reich Chancellor
and the Reich Ministers, that is, a collective, unified body. The Führer
was the Reich Government, and this power had slipped into his
hands—and one will naturally say that it should not have slipped
into his hands. All I can say to this, is that it may have been wrong,
it may have been stupid, but it was not a crime. It was a political
development such as has happened repeatedly in history. I might
recall the fact that in ancient Rome, where the senate had the power
and that there...
<span id="Page_41" title="41"></span></p>
<p class="pindent">THE PRESIDENT: The Tribunal really does not want to hear a
history of ancient Rome.</p>
<p class="pindent">LAMMERS: Very well.</p>
<p class="pindent">DR. SEIDL: Witness, you have described the development of the
transfer of governmental powers into Hitler’s hands...</p>
<p class="pindent">LAMMERS: Yes, but not completely.</p>
<p class="pindent">DR. SEIDL: In that case, please continue with your account. But
all descriptions...</p>
<p class="pindent">THE PRESIDENT: We have had quite enough. We quite understand
that he is saying that Hitler took over all powers and would
not listen to any debate at all. It is perfectly clear that he said so.</p>
<p class="pindent">DR. SEIDL: Yes.</p>
<p class="pindent">Witness, will you please tell me one more thing about the last
question in this connection? Please tell me whether you as Reich
Minister and Chief of the Reich Chancellery considered legal the
development you have just described.</p>
<p class="pindent">LAMMERS: I regarded this development, in the first place, from
the point of view of constitutional law. I have discussed these questions
repeatedly with Hitler, and I consider this development perfectly
legal and, if it is desired, I can explain my reasons in detail.</p>
<p class="pindent">In particular, I considered this development legal in view of the
well-known Enabling Act and later laws which gave the Reich
Government plenipotentiary powers and because of which the Reich
Government, in turn, were in a position to delegate some of these
powers to the Führer and to transfer this power. In that manner
that which the Reich Government, as soon...</p>
<p class="pindent">THE PRESIDENT: Dr. Seidl, the Tribunal is not really interested
in whether or not it was legal. What the Tribunal is interested
in is whether crimes against other nations were committed. We
certainly do not want to hear this in such great detail.</p>
<p class="pindent">DR. SEIDL: Yes, but the main point of the Indictment is Count
One of the Indictment; and that is concerned with the Conspiracy
charged by the Indictment.</p>
<p class="pindent">THE PRESIDENT: The main point in the Indictment is not
whether it was in accordance with German law that Hitler should
take over the powers of his Government. There was no such point
made in the Indictment.</p>
<p class="pindent">DR. SEIDL: Witness, I now turn to some questions which concern
the Defendant Dr. Frank. Since when have you known Dr. Frank?
What were his activities up to the outbreak of the war?</p>
<p class="pindent">LAMMERS: I became acquainted with Herr Frank in the course
of the year 1932. If I understand you rightly, you want to hear
about his activities only from the outbreak of the war?
<span id="Page_42" title="42"></span></p>
<p class="pindent">DR. SEIDL: Up to the outbreak of the war.</p>
<p class="pindent">LAMMERS: He was Chief of the Legal Division of the Party,
then Chief of the National Socialist Lawyers’ Association (Juristenbund)
which later on became the so-called Lawyers’ League (Rechtswahrerbund).
Then he became a member of the Reichstag, and at
the time of the seizure of power in 1933, he became Minister of
Justice in Bavaria. At the same time he became Reich Commissioner
for Legal Reforms.</p>
<p class="pindent">Later on—and I do not remember the exact year—he became
Reich Minister without Portfolio; and he was the President of the
Academy of German Law. He finally became Governor General.</p>
<p class="pindent">THE PRESIDENT: We have had the Defendant Frank’s posts
proved to us already, I should think, probably more than once. We
do not require them from Dr. Lammers.</p>
<p class="pindent">DR. SEIDL: I can put another question to the witness.</p>
<p class="pindent">Witness, what was the relationship between Frank and Hitler?</p>
<p class="pindent">LAMMERS: The relationship between the two was, at the beginning,
I should like to say, good and proper, but not particularly
close. At any rate, during the whole time he did not belong to those
who could be called the closest advisers of the Führer.</p>
<p class="pindent">DR. SEIDL: What was Frank’s attitude towards the “Police
State” and the question of concentration camps?</p>
<p class="pindent">LAMMERS: Frank repeatedly made speeches in public in which
he stood up for the constitutional state, for right and law, by
attacking the “Police State” and in which—although not in very
strong terms—he always took a stand against internment in concentration
camps, because such internment was without a legal basis.
These speeches made by Frank were frequently the cause of severe
disapproval on the part of Hitler, so that in the end the Führer instructed
me to forbid his making speeches and he was forbidden to
publish the printed version of these speeches. Finally, Frank’s activity
in standing up for the constitutional state resulted in his being
removed from his office as the Reich Chief of the Legal Division
of the Party.</p>
<p class="pindent">DR. SEIDL: Was he not dismissed from his position as President
of the Academy of German Law for these reasons?</p>
<p class="pindent">LAMMERS: Yes, that happened at the same time—and also from
his position as Chief of the Lawyers’ League.</p>
<p class="pindent">DR. SEIDL: Another question: Did Dr. Frank as Governor
General have considerable power, or was it not rather the case that
his power in many respects was greatly infringed upon?</p>
<p class="pindent">LAMMERS: One can certainly say that in many respects his
power was infringed upon.
<span id="Page_43" title="43"></span></p>
<p class="pindent">There are a number of reasons—first of all, as is self-evident, the
Armed Forces. But they bothered him least of all, for in the occupied
territories, the Reich commissioners were never members of
the High Command of the Armed Forces. That was always separate.</p>
<p class="pindent">Then Göring, as Delegate for the Four Year Plan, had comprehensive
powers to issue orders to both the Party and the State
in all occupied territories, therefore also in the Government General,
and thus could give orders to the Governor General and could,
when it was necessary in the interests of the whole, countermand
and annul the latter’s decrees.</p>
<p class="pindent">Thirdly, Frank’s powers as Governor General were considerably
limited through the police, since Himmler as Chief of the German
Police had direct police powers which he was, to be sure, to co-operate
with those of the Governor General but which he did not
always do. The Governor General suffered a further loss of power
through the fact that Himmler was Reich Commissioner for the
Preservation of German Nationality and as such could undertake
resettlements and did do so without consulting Governor General
Frank in any way.</p>
<p class="pindent">Then, there were certain infringements in favor of the Plenipotentiary
for the Allocation of Labor, but in my opinion the infringement
of power in this field was very slight, for Gauleiter
Sauckel always, where possible, came to an agreement with the local
offices beforehand.</p>
<p class="pindent">Finally there were powers reserved for Reich Minister Speer in
the field of armament and technology. There were still other powers
reserved for the postal service, the railroads, <span class="it1">et cetera</span>. But in the
main, these are the gaps, as you call them, Dr. Seidl, in Frank’s
power.</p>
<p class="pindent">DR. SEIDL: What, according to your observations, was Frank’s
basic attitude towards the Polish and Ukrainian peoples, and what
was the policy he tried to carry through?</p>
<p class="pindent">LAMMERS: In my opinion Frank always tried to pursue a policy
of moderation and to create an atmosphere of friendship towards
Germany in Poland. To be sure, he very often was unable to achieve
his aim, especially because of the fact that the powers of the police
and Himmler’s powers were too great in the field of resettlement, so
that his measures and his intentions suffered set-backs. He found it
difficult to achieve his aims.</p>
<p class="pindent">DR. SEIDL: Did Dr. Frank occupy himself with Germanization
aims or did he rather, whenever he could, oppose the policy of
resettlement pursued by Himmler as Reich Commissioner for the
Preservation of German Nationality?
<span id="Page_44" title="44"></span></p>
<p class="pindent">LAMMERS: I should not have thought that Frank would be so
foolish as to have germanizing intentions or to want to make
Germans of Poles. He probably tried to win the people of German
origin in Poland for the cause of Germanism. He had many difficulties
with regard to the resettlements, since he was not consulted
beforehand and since, by way of resettlement, people were simply
shoved into the Government General. In that respect he and I
agreed entirely. I have repeatedly told the Führer that these mass
resettlements could not take place, all at once, without the agreement
of the Governor General, and that the Governor General could
not govern if he did not know about these resettlement measures
in advance and if he could not even exert an influence in connection
with these measures.</p>
<p class="pindent">DR. SEIDL: Witness, you stated earlier that the entire Security
Police and the SD in the Government General were directly under
Himmler or the Higher SS and Police Chief. Did Governor General
Frank not try to protest against the policy of force employed by
these two men and to relieve the situation?</p>
<p class="pindent">LAMMERS: On this point he addressed repeated complaints to
me, so that I might take them to the Führer, which, however, I
could do only in part. In one point, however, we did want to help
him. In the Government General there had been established a
Secretariat of State for the security system. This was under Krüger,
then Higher SS and Police Chief. This, however, functioned for only
4 to 6 weeks and then differences of opinion in this field broke out
once more. The State Secretary for Security, Krüger, stated, “I
receive my orders from Himmler.” If the Governor General complained
about that, then Himmler said, “These are all unimportant
matters. I certainly must be able to rule on them directly.” The
Governor General said, “But for me they are not unimportant; even
those things are important to me.”</p>
<p class="pindent">The channels of command and the co-operation with the Governor
General were not being observed, and it is therefore perfectly understandable
that Herr Frank had a very difficult position with respect
to the police system.</p>
<p class="pindent">DR. SEIDL: Is it correct that the Governor General repeatedly,
both orally and in writing, declared his intention of resigning and
the reasons for it?</p>
<p class="pindent">LAMMERS: He repeatedly offered his resignation, because of
these sharp conflicts which he had, with Himmler in particular, and
because Hitler usually decided that he was in the wrong and
Himmler in the right. Many statements of his intention or desire
to resign were brought to me, some of which I was not even allowed
to submit to the Führer. But I informed the Führer of the Governor
<span id="Page_45" title="45"></span>
General’s intentions of resigning and the Führer several times
refused Frank’s offer to resign.</p>
<p class="pindent">DR. SEIDL: Do you know that Reichsführer SS Himmler was
working towards having Frank removed?</p>
<p class="pindent">LAMMERS: Reichsführer Himmler personally was indubitably
an opponent of Frank’s. There is cause for me to assume from
various disapproving statements made by Himmler with regard to
Frank that Himmler would have liked it very much if Frank had
been removed from his position; and Reichsleiter Bormann who also
was not very well disposed to Frank’s personality, would have liked
it also.</p>
<p class="pindent">DR. SEIDL: Who in the Government General had jurisdiction
over the concentration camps and was the competent official as far
as their establishment and administration were concerned?</p>
<p class="pindent">LAMMERS: The concentration camps were under Himmler, and
organs and departments under Himmler’s control were responsible
for the administration and organization. There was an economic department,
I believe, attached to the SS, which was responsible for
administration; but concentration camps as such were under Himmler’s
jurisdiction.</p>
<p class="pindent">DR. SEIDL: Who was responsible for all questions connected with
the so-called Jewish policy in the Government General?</p>
<p class="pindent">LAMMERS: In occupied territories the Jewish policy, I might
say, in its larger implications was handled by Himmler, who directed
it. But, of course, the Governor General was also concerned with
matters in the field of Jewish policy or with measures against the
Jews, for instance, the combating of spotted fever, and, I think, the
marking by means of a visible sign. All personal measures were
proposed to the Governor General by the Police. But the main policy
in Jewish questions, as I learned afterwards, was handled entirely
alone by Himmler, who had been given these powers by the Führer.</p>
<p class="pindent">DR. SEIDL: Is it true that the Governor General, as early as
1940, continuously raised complaints regarding the activities of the
Higher SS and Police Chief Krüger?</p>
<p class="pindent">LAMMERS: I can confirm that. That happened several times.
In particular these complaints were made because the SS and Police
courts were assuming powers in the Government General which
they did not actually have. Consequently, they deprived the Governor
General, the only authority competent in this respect, of the
administration of justice. There were also shootings of hostages. He
repeatedly complained about that. I want to state that all complaints
were addressed to me—there were no complaints to me but
they were merely always directed to me—so that I could submit
them to the Führer.
<span id="Page_46" title="46"></span></p>
<p class="pindent">DR. SEIDL: Is it correct that the Governor General continuously
made objections about the extensive claim made by the Reich on the
Government General, particularly in reference to grain deliveries?</p>
<p class="pindent">LAMMERS: He had often raised objections but the demands
which were put to him were even increased. He did, for the most
part, fulfill them, which must have been extremely hard for him.</p>
<p class="pindent">DR. SEIDL: Do you know that the Governor General protested
against the removal of art treasures by Himmler’s organization?</p>
<p class="pindent">LAMMERS: Yes; I have only a very faint recollection of that. It
is possible that he also complained about the removal of art treasures,
but I cannot remember any details in that connection.</p>
<p class="pindent">DR. SEIDL: And now the last question. Is it true that the Governor
General, in many documents, from as early as 1940 on, made
proposals to the Führer regarding the improvement of living conditions
of the population in the Government General and that the
Führer only very much later acknowledged that the high policy
which had been advocated by Frank from the very beginning was
correct?</p>
<p class="pindent">LAMMERS: Herr Frank had often objected to a policy of exploitation
and pronounced himself in favor of a policy of reconstruction,
in cultural matters as well. He had suggested, for instance,
that Polish advisory committees be assigned to the authorities under
the Governor General and to the district chiefs, and so forth; that
was refused. He spoke in favor of the creation of high schools,
theological seminaries, and similar cultural aims, all of which were
rejected.</p>
<p class="pindent">On one occasion he had submitted a long memorandum. This
referred to a Polish organization which called itself “The Plough and
the Sword.” It had offered to co-operate with the Germans, and
Frank submitted detailed proposals in a long memorandum, saying
that these Poles could be won over to co-operate only if they were
met on proper terms. All these suggestions, coming from Frank,
were turned down by Hitler. It is not correct for you to say,
Dr. Seidl, that it was not until the last moment that the Führer
agreed to these suggestions; all I can say is that they were all
turned down without exception.</p>
<p class="pindent">DR. SEIDL: I have no further questions.</p>
<p class="pindent">DR. ALFRED THOMA (Counsel for Defendant Rosenberg): By a
decree of 17 July 1941 the Defendant Rosenberg was appointed
Reich Minister for the Occupied Eastern Territories. Would you
please tell the Tribunal very briefly by means of what decrees his
authority in the East was limited?</p>
<p class="pindent">LAMMERS: I can do that very briefly by repeating what I said
before. The same limitations which applied to the Governor General
<span id="Page_47" title="47"></span>
also apply to him—these limitations which I have just listed; but I
have to add one thing more to that.</p>
<p class="pindent">The position of Reich Minister Rosenberg was made particularly
difficult through the fact that the difference of opinion which existed
between him and Minister Goebbels in the field of propaganda was
especially detrimental for him. For in the Führer’s opinion Rosenberg
was to decide on the Eastern policy and Goebbels was to decide
on the propaganda, and these two things could not always be co-ordinated.
There were strong differences of opinion between Rosenberg
and Goebbels which could be settled only after lengthy negotiations.
But the practical success was always slight, because the
difference of opinion, which had scarcely been settled, arose again
without delay in the next few weeks. There was also another limitation
which is different from the case of the Government General,
that is, that Rosenberg had two Reich commissioners for the Occupied
Eastern Territories, Reich Commissioner Lohse and Reich Commissioner
Koch.</p>
<p class="pindent">DR. THOMA: I am coming to that later.</p>
<p class="pindent">Can you remember that before the 17 July 1941 decree there had
been a conference with the Führer, on the day before, on 16 July
1941, during which, right from the beginning, Rosenberg complained
that his ministry was to have no police powers and that all police
powers were to be transferred to Himmler?</p>
<p class="pindent">LAMMERS: Herr Rosenberg was, of course, not quite in agreement
with the vesting of police powers in Himmler. He did object
to that but without success. Police matters in other occupied territories
had been ruled upon in the same way as in this case. The
Führer would not depart from his views.</p>
<p class="pindent">DR. THOMA: In the general instructions to the Reich commissioners
there is a passage where it says that the Higher SS and
Police Chief is directly subordinate to the Reich commissioner himself.
Did this mean that the Police Chief could also give orders to
the Reich commissioner in technical matters?</p>
<p class="pindent">LAMMERS: Normally, no; Himmler had reserved technical instructions
for himself. The SS and Police Chief was instructed to
get in touch with the Reich commissioner and, of course, to take into
consideration the latter’s political instructions, but not the technical
ones.</p>
<p class="pindent">DR. THOMA: Not the technical ones? Please tell the Tribunal,
but also quite briefly, what Rosenberg’s political concepts were,
from the beginning until the end, with reference to the treatment
of the Eastern peoples.</p>
<p class="pindent">LAMMERS: In my opinion he always wanted to pursue a
moderate policy. Beyond a doubt he was opposed to a policy of
<span id="Page_48" title="48"></span>
extermination and a policy of deportation, as was often preached.
He made efforts to create order in the field of agriculture by means
of his agrarian policy, likewise to create order in the field of education,
church matters, universities, schools, and so forth. But he
had little success, since one of the two Reich commissioners, namely
Koch, in the Ukraine, opposed Rosenberg’s measures, or rather
simply disregarded Rosenberg’s orders in respect to these matters.</p>
<p class="pindent">DR. THOMA: I am thinking about the large political conceptions.
Did he ever mention to you that he had the idea of leading the
Eastern peoples to a certain autonomy and of allowing them such
an autonomy?</p>
<p class="pindent">LAMMERS: Yes, I can answer that in the affirmative.</p>
<p class="pindent">DR. THOMA: Did he also mention to you that he intended that
sovereign right should be extended to the Occupied Eastern Territories?</p>
<p class="pindent">LAMMERS: Whether he said it in just that form, that I cannot
recollect. At any rate he was in favor of establishing a certain
independence for the Eastern peoples.</p>
<p class="pindent">DR. THOMA: That is to say autonomy. And was it for this
reason that he was so deeply interested in tending to the cultural
life of these Eastern peoples?</p>
<p class="pindent">LAMMERS: Yes. He was particularly interested in that. I know
that because he also took an interest in the school system, the
church, and the universities.</p>
<p class="pindent">DR. THOMA: Was that possibly the cause of the conflict which
he especially had with Reich Commissioner Koch?</p>
<p class="pindent">LAMMERS: That and many other things. Koch was above all
a strong opponent of the agrarian policy. That agrarian policy
which Rosenberg considered especially favorable in the interest of
his aims was sabotaged by Koch.</p>
<p class="pindent">DR. THOMA: Can you mention any other fields in which Koch
made difficulties for the Minister for the Eastern Territories?</p>
<p class="pindent">LAMMERS: I cannot at the moment recollect any.</p>
<p class="pindent">DR. THOMA: Do you know that there was a final row between
the two when you were given the order, in collaboration with Bormann,
to conduct negotiations between the two, and that Rosenberg
refused and demanded that the matter be brought before the Führer?</p>
<p class="pindent">LAMMERS: The differences of opinion between Rosenberg and
Koch were very numerous. They filled volumes and volumes of
records. The Führer had given the order that Bormann and I should
investigate these matters. Many weeks of investigation ensued; and
after the investigation I must say there was never a decision made
<span id="Page_49" title="49"></span>
by the Führer. The Führer always postponed making a decision
on these matters. On one occasion—perhaps that is the case which
you, Dr. Thoma, are thinking of—the differences of opinion were
again particularly sharp. The Führer then sent for Rosenberg and
Koch, and instead of settling these differences of opinion, again no
agreement was reached. Instead of a real decision, the compromise
was made that these two gentlemen should meet once every month
and co-operate. That was naturally, in the first place, an unbearable
situation for Rosenberg, that he, as the minister in charge,
should in every instance have to come to an agreement with the
Reich commissioner subordinate to him; in the second place, it could
hardly be carried out in practice. Firstly, the two gentlemen met
no more than once or twice at most, and then when they did meet
no agreement could be reached, and in the long run the Führer
thought that Koch was in the right.</p>
<p class="pindent">DR. THOMA: How could it be seen that Koch was considered
right?</p>
<p class="pindent">LAMMERS: Because the Führer reached no decision in regard
to the complaints made by Rosenberg which, in my opinion, were
justified. Thus the things accomplished by Koch remained.</p>
<p class="pindent">DR. THOMA: Defendant Rosenberg says that the result was that
Hitler gave him the order to confine himself in the administration
of the Eastern territories to the most basic lines. Is that right?</p>
<p class="pindent">LAMMERS: That was approximately the Führer’s order. Both
had agreed to come to a mutual understanding on the matter about
which the Führer had misgivings.</p>
<p class="pindent">DR. THOMA: What form did Rosenberg’s relationship to the
Führer take and when was Rosenberg’s last report to the Führer?</p>
<p class="pindent">LAMMERS: As far as I know, Rosenberg visited the Führer at
the end of 1943 for the last time; and even before that he had
always had considerable difficulties in getting to see the Führer.
He was not very often successful.</p>
<p class="pindent">DR. THOMA: Did this tense situation have the result that Rosenberg
offered his resignation in the autumn of 1940?</p>
<p class="pindent">LAMMERS: Yes, it was not actually an application for resignation,
since the Führer had prohibited such applications, but he did
say that if he could no longer conduct affairs to the Führer’s satisfaction,
he would like to be removed from office, thus, in the end,
it amounted to an application for resignation.</p>
<p class="pindent">DR. THOMA: Can you tell the Tribunal to what extent Rosenberg
had influence and popularity among the population in the Occupied
Eastern Territories? Is it correct, particularly, that a number of
church leaders in the Occupied Eastern Territories sent telegrams
<span id="Page_50" title="50"></span>
of thanks to him because of his tolerant attitude and because he
allowed them to practice their religion freely?</p>
<p class="pindent">LAMMERS: I know of that only superficially, from personal
statements made to me by Rosenberg. He may have once told me
something like that.</p>
<p class="pindent">DR. THOMA: I have another question. It has repeatedly come
to light during this Trial that Hitler’s military entourage considered
him a military genius. What was the situation in the administrative
sphere? Hitler was above all the supreme legislator, the supreme
chief of Government and Head of State. Did his administrative
entourage encourage him in the belief that all his decisions were
correct and that he was doing something extraordinary, or who did
strengthen him in this belief?</p>
<p class="pindent">LAMMERS: In this sphere, too, the Führer had an extraordinarily
quick power of perception and almost always a correct evaluation
of affairs. He was in a position to make frequent use of the
large-scale policy which he alone had to determine for legislation
and administration. It was then the task of the gentlemen who
were to carry this out; above all, the ministers—I, too, to a certain
extent—to shape into an appropriate form those suggestions and
basic thoughts which he had formulated. If any objections did arise
in this connection, the Führer was for the most part willing to
listen to them, as long as they did not touch the principle of the
matter; he was thus ready to listen to questions of severity, mitigation,
or greater stringency, if necessary, or to questions of formulation
and construction, but not if a basic tendency was being
attacked. Then one had great difficulties with him.</p>
<p class="pindent">DR. THOMA: And as far as individual problems were concerned,
did he personally make the pertinent decisions about everything, or
was he hampered in any way by his purpose, by certain aims which
he had in mind?</p>
<p class="pindent">LAMMERS: Very little was reported to him. Normally, in the
last years I made official reports every 6 or 8 weeks; in other words
six or eight times a year or perhaps, at the most, 10 times. On
these occasions, problems could not be discussed. Generally speaking,
the Führer left the administration to his ministers...</p>
<p class="pindent">THE PRESIDENT: We have heard it over and over again about
Hitler.</p>
<p class="pindent">DR. THOMA: I have only one more question. Did you know
anything regarding the fact that Hitler had decided to solve the
Jewish question by the final solution, that is, by the annihilation
of the Jews?</p>
<p class="pindent">LAMMERS: Yes, I know a great deal about that. The final solution
of the Jewish question became known to me for the first time
<span id="Page_51" title="51"></span>
in 1942. That is when I heard that the Führer supposedly, through
Göring, had given an order to the SS Obergruppenführer Heydrich
to achieve a solution of the Jewish question. I did not know the
exact contents of that order and consequently, since this did not
come within my jurisdiction, at the beginning I took a negative
attitude, but then as I wanted to know something I, of course, had
to contact Himmler. I asked him what was really meant by the
idea of the final solution of the Jewish question. Himmler replied
that he had received the order from the Führer to bring about the
final solution of the Jewish problem—or rather Heydrich and his
successor had that order—and that the main point of the order was
that the Jews were to be evacuated from Germany. With that statement
I was satisfied for the time and waited for further developments,
since I assumed that I would now in some way—I really had
no jurisdiction here—I would obtain some information from Heydrich
or his successor, Kaltenbrunner.</p>
<p class="pindent">Since nothing did come I wanted to inform myself about this,
and back in 1942 I announced a report to the Führer, whereupon the
Führer told me that it was true that he had given Himmler the
order for evacuation but that he did not want any further discussion
about this Jewish question during the war. In the meantime or
shortly afterwards—this was already at the beginning of 1943—the
RSHA sent out invitations to attend a meeting on the subject,
“Final Solution of the Jewish Question.” I had previously sent out
an order to my officials that I was not defining my attitude to this
matter, since I wanted to present it to the Führer. I merely ordered
that, if invitations to a meeting were sent out, one of my officials
should attend as a so-called “listening post.”</p>
<p class="pindent">A meeting actually did take place afterwards to discuss this
question, but without results. Minutes were taken and the various
departments were supposed to express their attitude. When I
received these minutes I found that they contained nothing vital.
For a second time I forbade taking a definite attitude. I myself
refused to take a stand and I remember it very well indeed, because
I received a letter which, first of all, was signed by some unimportant
man who, as far as I was concerned, had no right to sign. He
asked me why I had not yet taken a stand. Secondly, the tone of
the inquiry was very unfriendly; he said that everybody had
expressed an opinion except me. I ordered that the reply be made
that I refused to define my views since I wished to discuss the
matter with the Führer first.</p>
<p class="pindent">In the meantime I once more turned to Herr Himmler. He was
of the opinion that it was necessary to discuss this question since
a number of problems would have to be solved, particularly since
the intention of achieving a final solution of the Jewish question
would probably extend to persons of mixed blood, first grade, and
<span id="Page_52" title="52"></span>
would also extend to the so-called “privileged” marriages, that is to
say, marriages where only one party was Aryan whereas the other
party was Jewish. The Führer stated once more that he did not
wish to have a report on it but that he had no objections to consultation
on these problems. That some evacuations had taken place
in the meantime had become known to me. At that time, at any
rate, not the slightest thing was known about the killing of Jews;
if crass individual cases came up, I always addressed myself to
Himmler and he was always very willing to settle these individual
cases.</p>
<p class="pindent">Finally, however, in 1943, rumors cropped up that Jews were
being killed. I had no jurisdiction in this field; it was merely that
I occasionally received complaints and on the basis of these complaints
I investigated the rumors. But, as far as I could tell, at any
rate, these rumors always proved to be only rumors. Every one
said he had heard it from somebody else and nobody wanted to
make a definite statement. I am, in fact, of the opinion that these
rumors were based mostly on foreign broadcasts and that the people
just did not want to say from where they had the information.</p>
<p class="pindent">That caused me once more to undertake an investigation of
this matter. First of all, since I, for my part, could not initiate
investigations of matters under Himmler’s jurisdiction, I addressed
myself to Himmler once again. Himmler denied any legal killings
and told me, with reference to the order from the Führer, that it
was his duty to evacuate the Jews and that during such evacuations,
which also involved old and sick people, of course there were cases
of death, there were accidents, there were attacks by enemy aircraft.
He added too, that there were revolts, which of course he
had to suppress severely and with bloodshed, as a warning. For the
rest, he said that these people were being accommodated in camps
in the East. He brought out a lot of pictures and albums and showed
me the work that was being done in these camps by the Jews and
how they worked for the war needs, the shoemakers shops, tailors
shops, and so forth. He told me:</p>
<div class="blockquote">
<p class="calibre3">“This is the order of the Führer; if you believe that you have
to take action against it then tell the Führer and tell me the
names of the people who have made these reports to you.”</p>
</div>
<p class="pindent">Of course, I could not tell him the names, first of all because
they did not want to be named, and secondly, they only knew these
things from hearsay, so as I said, I could not have given him any
definite material at all.</p>
<p class="pindent">Nevertheless, I once again reported this matter to the Führer,
and on this occasion he gave me exactly the same reply which I had
been given by Himmler. He said, “I shall later on decide where
<span id="Page_53" title="53"></span>
these Jews will be taken and in the meantime they are being cared
for there.”</p>
<p class="pindent">Then he said the same thing Himmler had said, which gave me
the impression that Himmler had told the Führer that Lammers
would come and probably report to him something about this.</p>
<p class="pindent">But that final solution of the Jewish problem was nevertheless
in my portfolio and I was determined to bring it up once again with
the Führer. I succeeded in doing so on the occasion of some particularly
crass cases in connection with this question, cases which were
such that the Führer let me talk to him about it. By way of example
I should mention the entire case.</p>
<p class="pindent">If a Jew was married to a German woman then he was considered
“privileged,” that is to say, he was not evacuated. But if
the wife had died...</p>
<p class="pindent">THE PRESIDENT: One moment, please...</p>
<p class="pindent">DR. THOMA: Mr. President, I myself should like to ask the witness
to speak more briefly. But I ask that this particular question
be admitted. In my opinion the witness is trying to describe how
this entire final solution of the Jewish problem was carried out
in secret and with deception being practiced on Hitler’s entire
entourage, and that is why I ask that the witness be allowed to
finish his statement since this is a very decisive point in the discussion.</p>
<p class="pindent">[<span class="it1">Turning to the witness.</span>] But, Witness, please be quite brief. I
am now putting this question to you: Did Himmler ever tell you
that the final solution of the Jewish problem would take place
through the extermination of the Jews?</p>
<p class="pindent">LAMMERS: That was never mentioned. He talked only about evacuation.</p>
<p class="pindent">DR. THOMA: He talked only about evacuation?</p>
<p class="pindent">LAMMERS: Yes, only about evacuation.</p>
<p class="pindent">DR. THOMA: When did you hear that these 5 million Jews had
been exterminated?</p>
<p class="pindent">LAMMERS: I heard of that here a while ago.</p>
<p class="pindent">DR. THOMA: In other words the matter was completely secret
and only very few persons knew of it?</p>
<p class="pindent">LAMMERS: I assume that Himmler arranged it so that no one
learned anything about it and that he formed his Commandos in
such a way that nobody knew anything about them. Of course,
there must be a large number of people who must have known
something about it.</p>
<p class="pindent">DR. THOMA: Can you tell me what people must have known
something about it, apart from those who actually carried out these
<span id="Page_54" title="54"></span>
exterminations? Who, apart from those people, must have known
something about it?</p>
<p class="pindent">LAMMERS: Well, to start with, Himmler must have passed his
order on to other people; and there must have been certain leading
officials, and these leading officials must, of course, have had other
leading officials subordinate to them who took charge of the Kommandos
and who kept everything completely secret.</p>
<p class="pindent">DR. THOMA: No further questions.</p>
<p class="pindent">THE PRESIDENT: We will adjourn now.</p>
<h3 class="calibre17 sigil_not_in_toc" id="pgepubid00005">[<span class="it1">A recess was taken.</span>]</h3>
<p class="pindent">DR. OTTO PANNENBECKER (Counsel for Defendant Frick):
Witness, you have already talked about a number of questions
which are also of importance for the defense of Defendant Frick,
since he was a member of the Reich Cabinet. Can you tell me on
the strength of what position, or what position it was, that you are
enabled to give these answers? I repeat, can you tell me what your
position was within the Reich Cabinet which enables you to answer
these questions?</p>
<p class="pindent">LAMMERS: You mean my own?</p>
<p class="pindent">DR. PANNENBECKER: Yes.</p>
<p class="pindent">LAMMERS: I was State Secretary in the Reich Chancellery and
I was the intermediary between the Führer and the Reich ministers,
with two exceptions: the Führer either had direct communication
with these gentlemen or the men in question had a way
prescribed to approach the Führer other than through me. There
were a number of things which did not go through my hands, but
which the ministers submitted to the Führer directly. These were
all matters of high policy, particularly of high foreign policy. Only
in 1937, on the occasion of certain changes in the Cabinet, did I
receive the title “Reich Minister,” but my tasks did not change. In
particular, I also had no departments.</p>
<p class="pindent">DR. PANNENBECKER: Can you tell me when the very last
meeting of the Reich Cabinet took place?</p>
<p class="pindent">LAMMERS: The Reich Cabinet met for the last time in November
1937. To be sure, in 1938, at the beginning of February, there
was one more so-called “information conference” of the ministers,
during which the Führer announced the change which had been
made in the Cabinet involving Herr Von Blomberg and Herr
Von Neurath. The last Cabinet meeting in which actual consultation
took place, namely in regard to the draft of a penal code,
took place in November 1937.
<span id="Page_55" title="55"></span></p>
<p class="pindent"> DR. PANNENBECKER: Can you tell me something about any
attempts after that date to get the ministers together?</p>
<p class="pindent">LAMMERS: After that date I continuously attempted to effect
a concentration of the Reich Cabinet, a reactivation, I might say.
This was continuously refused by the Führer. I had even prepared
a draft, a draft for a decree according to which ministers should at
least come together to consult with each other once or twice a
month under the chairmanship of Reich Marshal Göring, or, if he
were prevented from attending, with me as acting chairman. The
ministers were to come together and hear informal reports. That
was turned down by the Führer. Nevertheless, the ministers had
an urgent desire to meet. My next suggestion was that I invite
the ministers once or twice a month to a social evening, a beer
party, so that we could get together and talk. To that the Führer
replied, “Herr Lammers, this is not your concern; it is my concern.
The next time I go to Berlin, I will do that.”</p>
<p class="pindent">THE PRESIDENT: What are all these details about beer drinking?
If they did not meet and he applied to the Führer, asking them
to meet, and they never did, that is sufficient. What is the good of
going into detail?</p>
<p class="pindent">DR. PANNENBECKER: Is it correct, therefore, to say that the
Reich Ministers had to work on their own in their departments, in
their special field of activity, and that a Reich Cabinet as such,
which decided questions of policy and was informed and held discussions,
did not exist any more at all?</p>
<p class="pindent">LAMMERS: Actually the ministers were no more than the
highest administrative chiefs of their departments. They could no
longer act in the Cabinet of the Reich Government as political ministers.
I tried to describe that earlier. No more meetings took place;
conferences were even forbidden. So, how could it have been possible
for them to exchange views?</p>
<p class="pindent">DR. PANNENBECKER: Do you know anything about Hitler’s
statement considering the Reich Cabinet as a defeatist club, which
he did not want to see anymore?</p>
<p class="pindent">LAMMERS: In connection with my attempts to reactivate the
Reich Cabinet through certain meetings, the Führer told me that
this would have to be stopped since an atmosphere might arise
which he would not like. He did not use the words “defeatist club”
in my presence, but Reichsleiter Bormann told me that he said,
“The ministers are not to meet; that might become a defeatist club.”</p>
<p class="pindent">DR. PANNENBECKER: It has been discussed here frequently
that a Reich Minister on his own could not resign. Do you know
anything about Frick making an attempt to resign his post as
Reich Minister?
<span id="Page_56" title="56"></span></p>
<p class="pindent">LAMMERS: In spite of this prohibition by the Führer, Frick
repeatedly stated his wish to be relieved of his office if he no longer
enjoyed the Führer’s full confidence and if the Führer would not
receive him any more. He told me that frequently; but I cannot
recall a written application for resignation. Frick’s wishes to resign
were always passed on to the Führer by me although the Führer
always rejected such communications very bluntly.</p>
<p class="pindent">DR. PANNENBECKER: In August 1943 Frick left his post as
Reich Minister of the Interior. Do you know any details of what
he himself said in that connection?</p>
<p class="pindent">LAMMERS: At that time Herr Frick himself told me, “I am
happy to leave my post as Minister of the Interior, but please see
to it that the Führer does not make me Reich Protector of Bohemia
and Moravia, as he intends to do. I do not want that office. I want
to retire.” And I told that to the Führer.</p>
<p class="pindent">The Führer ordered Frick to come to headquarters. Before Frick
went in to see the Führer alone, he told me that he did not, under
any circumstances, want to accept the position of Reich Protector,
but when he came back from the Führer he had, nevertheless,
changed his mind and had accepted the office. If I am right this
must have been in August 1943.</p>
<p class="pindent">DR. PANNENBECKER: Frick’s position as Plenipotentiary General
for Reich Administration is also one of the points against him
in the accusation. Do you know anything about the appointment of
that office?</p>
<p class="pindent">LAMMERS: As Reich Plenipotentiary for Administration he had
the task of co-ordinating other ministries. The following were
co-ordinated: the Ministry of Interior, the Ministry of Justice, the
Ministry for Education, the Ministry for Churches, and the National
Office for Regional Planning. He co-ordinated them under his
administration and represented them, so to speak, in the Ministerial
Council for Defense of the Reich, which came into being in 1939
with the outbreak of the war.</p>
<p class="pindent">DR. PANNENBECKER: Can you tell me on the basis of what
regulations Frick was appointed Plenipotentiary General for Reich
Administration? There are two Reich defense laws, one of 1935
and one of 1938.</p>
<p class="pindent">LAMMERS: The Defense Law of 1935 I can no longer remember.
The draft of the Reich Defense Law of 1938, which was not published,
allots to the Plenipotentiary General for Reich Administration
a great number of tasks which, however, were never passed
on to him. He had merely the task of co-ordinating the various
departments, which I have just mentioned. At any rate he never
exercised actual powers as Plenipotentiary General for the Reich
<span id="Page_57" title="57"></span>
Administration to the extent to which they were allotted him in
the Reich Defense Law.</p>
<p class="pindent">DR. PANNENBECKER: In this connection one also talks of the
powers of a so-called Three Man College. This consisted of Plenipotentiary
General for Reich Administration Frick, Plenipotentiary
General for Economy Schacht—later Funk—and the Chief of the
OKW. Can you tell me what powers these three exercised?</p>
<p class="pindent">LAMMERS: The expression Three Man College is first of all
quite false; it is not a concept in constitutional law but merely a
term of convenience, a term used by officials. These three people,
the Plenipotentiary General for Administration, the Plenipotentiary
General for Economy, and the Chief of the OKW, each had the
power to issue decrees, but they were obliged to have the consent
of the other two—that is, with the agreement of the others, anyone
could give orders in his field. A meeting of this committee, this
so-called Three Man College, never took place. The decrees issued
by it are very few, insignificant, and quite unimportant. For instance,
I can remember that this committee ruled on the question
of reducing the numbers of judges in the disciplinary chambers;
that is in civil service matters. A second task in this sphere—in all,
there were six to eight decrees at the most, but altogether quite
unimportant.</p>
<p class="pindent">DR. PANNENBECKER: In addition there was later on the Ministerial
Council for Defense of the Reich. Can you compare these
two groups, those three and the Ministerial Council for Defense of
the Reich?</p>
<p class="pindent">LAMMERS: Do you mean the Three Man College for the Ministerial
Council?</p>
<p class="pindent">DR. PANNENBECKER: Yes.</p>
<p class="pindent">LAMMERS: First of all, after the Ministerial Council for Defense
of the Reich was established, it was my principle to stalemate this
Three Man College if possible, since it was not at all necessary.
The Ministerial Council for Defense of the Reich had the task of
issuing decrees with legal effect but it actually had nothing to do
with the Defense of the Reich. Military matters were never discussed
in this Ministerial Council for Defense of the Reich, nor did
it deal with foreign policy or propaganda. In the main it issued
decrees which had the effect of laws. Meetings took place only until
December 1939, and after that the members communicated with
each other by writing for the purpose of issuing decrees. Political
debates never took place.</p>
<p class="pindent">DR. PANNENBECKER: A Central Office was founded in the
Ministry of the Interior for the occupied territories. This Central
Office has been cited by the Prosecution as evidence of the fact that
<span id="Page_58" title="58"></span>
Frick had considerable administrative powers, and hence responsibility
for the occupied territories. Are you able to say anything
about that?</p>
<p class="pindent">LAMMERS: The Central Office had, in the main, two tasks. One
was the obtaining of civil servants, the other was assisting in the
issuing of laws and decrees in occupied territories. Such an office
was necessary because the occupied territories required personnel
and because the Reich commissioners in the occupied territories
were directly under the Führer’s command. Written communications
went in part through me. If personnel was to be provided
for within this framework, then I would have had to do it. But
I had no instrument for it. I had only a staff of 12 senior officials
and I had no organization in the country; I had no executive officials
in those countries. Therefore the Minister of the Interior was
brought in, since he had the whole civil service apparatus at his
disposal.</p>
<p class="pindent">DR. PANNENBECKER: You just said that the Central Office
gave some assistance in issuing decrees for the occupied territories.
Was it possible for the Central Office to issue a decree for, let us
say, Norway?</p>
<p class="pindent">LAMMERS: For what?</p>
<p class="pindent">DR. PANNENBECKER: To issue a decree for some occupied
territory, for instance Norway.</p>
<p class="pindent">LAMMERS: No, not of itself—at the most after the Reich commissioner
had agreed.</p>
<p class="pindent">DR. PANNENBECKER: Was it at all customary for the Central
Office at any time to issue a decree for a certain occupied territory?</p>
<p class="pindent">LAMMERS: To my knowledge that has never happened. I do
not know of a single case where the Central Office issued a decree.</p>
<p class="pindent">DR. PANNENBECKER: A decree by the Reich Minister of the
Interior has been cited which ruled on the question of citizenship,
also with reference to occupied territories.</p>
<p class="pindent">LAMMERS: Yes, about German citizenship probably.</p>
<p class="pindent">DR. PANNENBECKER: Yes.</p>
<p class="pindent">LAMMERS: Yes, but that was certainly an internal German
matter.</p>
<p class="pindent">DR. PANNENBECKER: Did the Central Office have any right
to issue instructions either to the German Plenipotentiary in the
occupied territory, say the Reich Commissioner for Norway...</p>
<p class="pindent">LAMMERS: No, they had no such right at all.</p>
<p class="pindent">DR. PANNENBECKER: Or did they have a right to issue instructions
to lower offices—German offices—or to the occupied territories
themselves?
<span id="Page_59" title="59"></span></p>
<p class="pindent">LAMMERS: No, they did not have the right to give instructions.</p>
<p class="pindent">DR. PANNENBECKER: The Prosecution have further stated that
the Central Office also had the right to issue instructions in those
territories for which it had not been specifically appointed. Is there
any legal provision or any practical case where the Central Office
interfered with jurisdiction in the occupied territories?</p>
<p class="pindent">LAMMERS: No case is known to me.</p>
<p class="pindent">DR. PANNENBECKER: Is it then correct to say that the chiefs
of the civil administration in the occupied territories were always
directly subordinate to Hitler as the Führer, no matter what their
official designation was?</p>
<p class="pindent">LAMMERS: In the occupied territories the Reich commissioners
of the so-called chiefs of the civil administration were directly subordinate
to the Führer.</p>
<p class="pindent">DR. PANNENBECKER: Did Frick, as Minister of the Interior,
have the power to issue orders for the occupied territories insofar
as the German Police was active in the occupied territories?</p>
<p class="pindent">LAMMERS: No, the police authority in occupied territories was
vested solely in Himmler who was to act in agreement with the
Reich commissioners. The Minister of the Interior had nothing at
all to do with the police in occupied territories.</p>
<p class="pindent">DR. PANNENBECKER: Must it not be concluded from that that
this matter came within the competency of the Reich Minister of
the Interior insofar as Himmler was subordinate to the Reich Ministry
of the Interior?</p>
<p class="pindent">LAMMERS: There would have been at most a power to issue
orders for Germany but not for the occupied territories, and to what
extent this power existed for Germany herself is also problematic.</p>
<p class="pindent">DR. PANNENBECKER: I shall come to that later in detail. Can
you tell me what powers the Minister of the Interior had in the
police field during that time when the police were still under the
jurisdiction of the provinces of Prussia, <span class="it1">et cetera</span>, that is, from 1933
to 1936?</p>
<p class="pindent">LAMMERS: Well, his powers were in any case very limited, but
I cannot tell you the details.</p>
<p class="pindent">DR. PANNENBECKER: Did the Reich have the right of supervision?</p>
<p class="pindent">LAMMERS: Yes, the old right, as it was formerly—the Reich
had only the ultimate supervision.</p>
<p class="pindent">DR. PANNENBECKER: Of course, you know that later on,
through a decree, Himmler was appointed Reichsführer SS and Chief
of the German Police in the Ministry of the Interior, do you not?
<span id="Page_60" title="60"></span>
Do you know who created that designation, “Reichsführer SS” and
so forth?</p>
<p class="pindent">LAMMERS: Yes, I had something to do with it at the time. The
proposal of such a title originated apparently with Himmler. I objected
to this title from the very beginning for two reasons. Two
entirely different matters were being lumped together: the Reichsführer
SS, which is a Party affiliation, and the Police, which is a
State concern. On the one side was the Reichsführer SS who has
the rank of a Reichsleiter in the Party, which is equivalent to that
of a Reich minister; on the other side the Chief of Police, who has
the position of a State Secretary in the Ministry of the Interior and
who is subordinate to the Minister of the Interior. But Himmler
insisted on this designation, and the Führer considered that he
was right.</p>
<p class="pindent">My objections to this designation proved to be correct in practice,
for the Minister of the Interior’s right to issue instructions to
the Police now became extremely problematic, since Reichsführer
Himmler, as far as the police officers were concerned, was, at the
same time the SS Führer and could give them orders in his capacity
as Reichsführer SS, and the Ministry of the Interior could not interfere.
It was also a practice of his that he usually made the other
police officials SS leaders. One therefore could never know exactly
in what capacity the person concerned was acting, whether he was
acting as member of the SS, or as a member of the Police. And the
question of authority in the Ministry of Interior afterwards became
almost devoid of meaning, because Himmler dropped the last words
of the designation, “Chief of the German Police in the Reich Ministry
of the Interior,” and completely separated himself from the
Ministry of the Interior as far as having an office in the building
and the mode of procedure were concerned, and no longer felt himself
in a subordinate position.</p>
<p class="pindent">When Minister Frick lodged a complaint about this with me,
which I was supposed to take to the Führer, the Führer told me,
“Tell Herr Frick that he should not restrict Himmler as Chief of
the German Police too much; with him the Police is in good hands.
He should allow him as much free rein as possible!”</p>
<p class="pindent">Thus for all practical purposes, though not by a special decree,
the Minister of the Interior’s authority to give orders was very
sharply limited, if not even suspended.</p>
<p class="pindent">DR. PANNENBECKER: You have just said that Himmler, on
his own, arbitrarily exercised jurisdiction over police organizations
without bothering about what Frick wanted. But then there was
still another channel for commands issued to the police, orders given
by Hitler himself. Did he give them to Frick as the competent
minister, or did he give them to Himmler?
<span id="Page_61" title="61"></span></p>
<p class="pindent">LAMMERS: Normally the Führer gave these instructions to
Himmler. If he gave instructions to me which concerned police
matters then I generally passed them on through the Minister of
the Interior, or at least I informed him about them.</p>
<p class="pindent">DR. PANNENBECKER: Do you know anything about whether
concentration camps were included in the budget of the Reich or
whether they were in the budget of the SS?</p>
<p class="pindent">LAMMERS: As far as I know—but I cannot say this for certain—the
funds for concentration camps did not appear in the
budget of the Reich. It was rather this way: The Reich Minister
of Finance paid a yearly lump sum to the Party through the Reich
Treasurer, who had to distribute it to the various Party organizations.
The Reichsführer SS received a lump sum from the SS
with which he probably financed this matter. I also cannot recollect
that I ever saw any part of the Reich budget in which the concentration
camps were mentioned.</p>
<p class="pindent">DR. PANNENBECKER: Do you know anything about the fact
that Himmler opposed the Minister of the Interior’s right to interfere
in this field, giving as his reason the fact that the funds for
concentration camps had been provided for?</p>
<p class="pindent">LAMMERS: No, I do not know anything about that.</p>
<p class="pindent">DR. PANNENBECKER: I now have some questions referring to
another field. Do you know anything about Hitler’s efforts to kill
incurably insane persons painlessly?</p>
<p class="pindent">LAMMERS: Yes, this idea occurred to Hitler in the autumn of
1939 for the first time. On that occasion the State Secretary in the
Ministry of the Interior, Dr. Conti, received the order to investigate
this question. He was told to discuss the legal aspect of the matter
with me. I spoke against the execution of any such program. But
since the Führer insisted on it I suggested that this matter should
be given all legal guarantees and be ruled upon by a law. I also
had an appropriate draft for a law worked out; thereupon State
Secretary Conti was relieved of this task, and in 1940 it was given
over to Reichsleiter Bouhler. Reichsleiter Bouhler reported to the
Führer, but I was not present. Then he came to see me. I showed
him my draft of the law and stated the objections I had to the
matter and he left again. Then I presented the drafted law to the
Führer; he did not approve of it, but he did not reject it altogether.
Later, however, ignoring me, he gave Reichsleiter Bouhler and
the medical attendant, Professor Dr. Brandt, then attached to him,
plenary authority to kill incurably insane people. I had nothing
to do with the drafting of this plenary power. As far as I was concerned,
the matter was settled, as the Führer did not want me and
had given the work to others to do.
<span id="Page_62" title="62"></span></p>
<p class="pindent">DR. PANNENBECKER: You have just said that the Führer gave
the task to State Secretary Dr. Conti in the Ministry of the Interior.
Did that order from Hitler pass to Conti through Frick?</p>
<p class="pindent">LAMMERS: I do not know. State Secretary Conti was called
by telephone by the adjutant’s office of the Führer or by Reichsleiter
Bormann; and whether that went through Frick or not, I do
not know.</p>
<p class="pindent">DR. PANNENBECKER: Do you know anything at all about
whether Frick himself participated in these measures in some form
or other?</p>
<p class="pindent">LAMMERS: No, nothing about that is known to me.</p>
<p class="pindent">DR. PANNENBECKER: Then I have a last group of questions,
referring to the Protectorate in Bohemia and Moravia. When, in
August 1943, Frick was appointed Protector for Bohemia and
Moravia did the formal authority of the Reich Protector remain
the same as before?</p>
<p class="pindent">LAMMERS: No. These powers were deliberately altered and in
such a way that the Reich Protector from then on was to become
a more or less decorative figure. The political direction of the
Protectorate was to be transferred to State Minister Frank. The
Reich Protector was merely the German representative in the
Protectorate with very little actual power. He co-operated in forming
the government in the Protectorate. Furthermore he had the
limited, rather small right of nominating civil servants, which in
the main applied to the medium and lower grade of civil servants;
and then he had the right of granting pardons. And in general the
State Minister for Bohemia and Moravia, Frank, was obliged to
keep the Reich Protector informed. In the main these were the
rights of the Reich Protector. Apart from that it was Hitler’s wish
that the Reich Protector did not spend too much time in the Protectorate.
In fact I have had to pass this information on to him
several times.</p>
<p class="pindent">DR. PANNENBECKER: You said that the Reich Protector of
Bohemia and Moravia during Frick’s time was the head of the
German administration. Was State Minister Frank under Frick?</p>
<p class="pindent">LAMMERS: Yes, he was subordinate but the relation was rather
that of the head of the State to the head of the Government; State
Minister Frank had the political control.</p>
<p class="pindent">DR. PANNENBECKER: But is it not right to say that Minister
Frank was directly subordinate to the Führer?</p>
<p class="pindent">LAMMERS: I do not believe that that was the situation. I do not
remember the decree. He was not directly under him—I cannot
<span id="Page_63" title="63"></span>
say that for certain now. At any rate the Führer received only
Frank and not the Reich Protector for political discussions.</p>
<p class="pindent">DR. PANNENBECKER: I do not have the decree with me. I shall
have to clear that up later.</p>
<p class="pindent">Do you know anything about the fact that Frick expressly
demanded this division of authority and that, to start with, he
had refused to accept the position of a Reich Protector in Bohemia
and Moravia; and that this division of authority did not take place
until he said that he could not assume outer responsibility for something
which was not his inner responsibility?</p>
<p class="pindent">LAMMERS: I have already mentioned the fact that Minister
Frick refused to accept this position, and when this decree appeared,
in which the rights of the Protector were laid down—a decree which
was not published—Dr. Frick quite rightly had misgivings, thinking,
“As far as the outside world is concerned, I shall have responsibilities
which are not known at all.” So we published a notice in the
press. In that it stated that the new Reich Protector would have
only such and such rights, as I previously listed here, such as the
nomination of civil servants, the right to pardon and the right to
co-operate in the forming of a government in the Protectorate.
Thus it was stated to the outside world that Frick no longer had
the full responsibility which former Reich Protectors had perhaps
had.</p>
<p class="pindent">DR. PANNENBECKER: Did you know anything about the fact
that the reason for this division of responsibility in the Protectorate
was that Hitler did not think that Frick would be hard enough to
handle matters there?</p>
<p class="pindent">LAMMERS: That was obviously the reason, yes.</p>
<p class="pindent">DR. PANNENBECKER: In that case I have no further questions.</p>
<p class="pindent">DR. FRITZ SAUTER (Counsel for Defendant Funk): As a supplement
to the statements already made by the witness, I have still
a few questions.</p>
<p class="pindent">Dr. Lammers, the Defendant Funk beginning with the year 1933
was the Press Chief of the Reich Government. That is known to you?</p>
<p class="pindent">LAMMERS: Yes.</p>
<p class="pindent">DR. SAUTER: You yourself were at that time already in your
office, were you not?</p>
<p class="pindent">LAMMERS: Yes.</p>
<p class="pindent">DR. SAUTER: Did the Defendant Funk in this capacity as Press
Chief of the Reich Government exercise any influence on decisions
made by the Reich Cabinet or on the contents of bills of the Reich
Cabinet?
<span id="Page_64" title="64"></span></p>
<p class="pindent">LAMMERS: That question must be answered in the negative.
At the most, he may have had an influence from the journalistic
point of view, that is, for an attractive title for a law, or some sort
of popular wording, or something like that. But he did not vote on
the contents of the laws. In his position as Press Chief, he was first
Ministerial Director and then State Secretary; he had nothing to say
about the contents.</p>
<p class="pindent">DR. SAUTER: Then why was he, as Press Chief of the Reich
Government, invited at all to attend the meetings of the Reich
Cabinet at that time?</p>
<p class="pindent">LAMMERS: Well, because of the reporting to the press afterwards.</p>
<p class="pindent">DR. SAUTER: That is to say, only to inform the press of the
discussions and decisions of the Reich Cabinet? And he had no
influence whatsoever on decisions or not on the bills either?</p>
<p class="pindent">LAMMERS: Yes, that is right.</p>
<p class="pindent">DR. SAUTER: But without having any influence on decisions or
the authority to propose laws.</p>
<p class="pindent">LAMMERS: Yes, that is right.</p>
<p class="pindent">DR. SAUTER: In this capacity as Press Chief of the Reich Government,
the Defendant Funk had, as you know, to give reports
regularly on press matters to the then Reich Chancellor, Hitler. Do
you know when these regular reports made by the Press Chief of
the Reich Government to Hitler ceased?</p>
<p class="pindent">LAMMERS: At the latest they ceased 1 year later. These were
joint conferences. Funk and I, at the beginning, had as many as
three to four meetings a week with the Führer, and this lasted
through the summer of 1933. During the winter the meetings became
fewer, then became more frequent again, and ceased altogether in
1934, after Von Hindenburg’s death.</p>
<p class="pindent">DR. SAUTER: Who made these press reports to Hitler after that?</p>
<p class="pindent">LAMMERS: The Press Chief Dr. Dietrich.</p>
<p class="pindent">DR. SAUTER: Excluding Dr. Funk?</p>
<p class="pindent">LAMMERS: Yes.</p>
<p class="pindent">DR. SAUTER: Dr. Lammers, the Defendant Funk later on became
President of the Reichsbank. Do you know anything about who had
to decide about credits given, or to be given, to the Reich by the
Reichsbank?</p>
<p class="pindent">LAMMERS: That decision was the Führer’s. The way it happened
in practice was that the Minister of Finance submitted the application
for a credit. That was done in duplicate. One letter with the
appropriate order was directed to the Reich Minister of Finance, and
<span id="Page_65" title="65"></span>
the second letter with such an order was addressed to the President
of the Reichsbank.</p>
<p class="pindent">DR. SAUTER: Dr. Lammers, these technical details do not really
interest us. We are only interested in this: Did Dr. Funk, as President
of the Reichsbank have any influence on the question of
whether and to what extent the German Reich could claim credit
from the Reichsbank? Only this interests us.</p>
<p class="pindent">LAMMERS: I can answer that only by citing technical details.
All I received were those two documents from the Finance Minister.
It was entirely a matter of having them signed. They were signed
in one second by the Führer and then they were sent back. I never
had an order to negotiate with Herr Funk or with Herr Schacht or
with the Minister of Finance. It was entirely a matter of having
them signed, nothing else.</p>
<p class="pindent">DR. SAUTER: So that according to your knowledge these instructions
came from Hitler and not from the Reichsbank president?</p>
<p class="pindent">LAMMERS: The instructions were signed by the Führer.</p>
<p class="pindent">DR. SAUTER: Dr. Lammers, you have already mentioned once
the so-called Committee of Three or Three Man College, which was
formed in the later years. Regarding this Committee of Three the
Prosecution maintain that Funk was also a member of this committee,
and that this committee represented, so to speak, the highest
court as far as the legislation of the Reich Government during the
war was concerned.</p>
<p class="pindent">LAMMERS: One cannot say that at all. I have already stated
that these three men, each acting independently, had the right to
issue decrees with the consent of the two others, and that there were
very few and quite insignificant decrees.</p>
<p class="pindent">DR. SAUTER: You mean decrees of little importance, decrees for
his department?</p>
<p class="pindent">LAMMERS: Yes.</p>
<p class="pindent">DR. SAUTER: Furthermore, Dr. Lammers, the Defendant Göring
stated during his examination that the powers which Dr. Funk had
as Plenipotentiary for Economy—I think in 1938—were transferred
for the most part to the Delegate for the Four Year Plan, that consequently
Dr. Funk’s powers, generally speaking, existed only on
paper. I should be very interested in knowing whether these powers
of the Plenipotentiary for Economy were transferred to the Delegate
for the Four Year Plan, in other words, Göring, formally, as
well as in fact.</p>
<p class="pindent">LAMMERS: That was based on a decree of the Führer and a
special order issued by the Führer.
<span id="Page_66" title="66"></span></p>
<p class="pindent">DR. SAUTER: When was that, approximately?</p>
<p class="pindent">LAMMERS: The Four Year Plan was set up in 1936, and it was
extended in 1940 for another 4 years. These special powers which
Herr Funk later surrendered to the Four Year Plan were based on
an agreement between Reich Marshal Göring and Minister Funk, an
arrangement which, as far as I know, had the Führer’s approval.</p>
<p class="pindent">DR. SAUTER: Dr. Lammers, you have already told the Tribunal
that since 1938, I think, no more meetings of the Cabinet took place
and that in the end Hitler even prohibited informal discussions
among ministers. Can you tell us anything as to whether and, if so,
how often the Defendant Dr. Funk had an opportunity, during the
7 years he was Minister, to talk to Hitler, to report to him, and
so forth?</p>
<p class="pindent">LAMMERS: Well, during the first years, as I have said, he
reported frequently as Press Chief.</p>
<p class="pindent">DR. SAUTER: And later as Minister of Economics?</p>
<p class="pindent">LAMMERS: Later, as Minister of Economics, he very rarely came
to the Führer. At many conferences he was not consulted, even at
conferences in which he ought to have been consulted. Quite often
he complained to me about that. I tried in every way to do my best
to include him in such conferences, but I did not always succeed.</p>
<p class="pindent">DR. SAUTER: Dr. Lammers, I have noticed that minutes have
been read here in which it is clearly said, and I think by you, that
the Defendant Funk as Minister for Economics has asked you that
he be permitted to participate in this or that important conference,
and that you had expressly stated in that record that the Führer had
refused that, or that the Führer had prohibited it. May I show you
an example? I remember a meeting of 4 January 1944, Document
1292-PS, concerning questions of labor employment. In those minutes
it says—once more said by you—that Funk’s request to be able to
participate had been refused. Can you remember such cases and can
you give us the reasons?</p>
<p class="pindent">LAMMERS: Yes, I can remember such cases, but I do not know
whether they were mentioned in the minutes. Probably I informed
Herr Funk that I had made the greatest effort to have him participate
in these conferences; the Führer, however, had refused.</p>
<p class="pindent">DR. SAUTER: The reason?</p>
<p class="pindent">LAMMERS: Frequently the Führer made objections; those were
various reasons in the case of Funk. He was sceptical about him and
did not want him there.</p>
<p class="pindent">DR. SAUTER: Witness, in April of 1941 you are supposed to have
informed the Defendant Dr. Funk that Rosenberg had received an
order from Hitler for a uniform treatment of the problems in the
<span id="Page_67" title="67"></span>
Eastern Territories. Besides giving that message to Funk you are
supposed to have passed it on to Göring and Keitel. From that fact
the conclusion has been drawn by the Prosecution that Funk was
one of the influential persons concerned with the preparation for
aggressive war against Russia.</p>
<p class="pindent">Can you tell us whether and, if so, why you also passed that
message on to the Defendant Funk at that time?</p>
<p class="pindent">LAMMERS: Either the Führer told me to do so—which I do not
think was the case—or I believed that from the economic point of
view Funk would be interested in this information. I passed it on to
him as a special personal gesture; I do not remember any particular
reason now. I certainly must have passed the same message on to
others, but not in writing; the others probably received it orally.</p>
<p class="pindent">There was no question at all of an aggressive war when Rosenberg
was given that task by Hitler. He was supposed to be merely
a sort of political commissioner for the Eastern Territories. He was
to study the conditions of the peoples there.</p>
<p class="pindent">DR. SAUTER: Dr. Lammers, roughly at the same time, that is to
say, the spring of 1941, and shortly before the beginning of the
Russian campaign, you are supposed to have had some further
discussions with the Defendant Funk on the subject of what turn the
foreign political situation in respect to Russia might possibly take
in the near future. On that occasion you are supposed to have told
Defendant Funk something regarding the reasons why Hitler believed
in the possibility of a war against Russia. What did you tell
Defendant Funk at that time regarding these preparations for the
war undertaken at one time or another?</p>
<p class="pindent">LAMMERS: It must have been what I knew myself at the time,
namely, information which the Führer had given me, that troop
concentrations in Russia had been observed, which allowed the
conclusion to be drawn that an armed conflict with Russia might
occur. These were the words the Führer used. He believed that
things would come to a head with Russia and therefore wished that
one man, and that was Rosenberg, should concern himself with
Eastern questions, since the possibility of an armed conflict with
Russia did exist. That is probably what I told Funk. I cannot
imagine what else I could have told him.</p>
<p class="pindent">DR. SAUTER: At that time, Dr. Lammers, you are supposed to
have mentioned not only troop concentrations on the Russian side
along the Eastern frontier of Germany, but also the Russian march
into Bessarabia.</p>
<p class="pindent">LAMMERS: Yes, it is possible that that was the case. The
Southeast, at any rate; and perhaps I mentioned that the discussions
which had taken place with Russia, with Molotov, were unsatisfactory.
<span id="Page_68" title="68"></span></p>
<p class="pindent">DR. SAUTER: In that connection, since you now refer to the
discussion with Molotov, you are supposed to have told Defendant
Funk in particular that Russia was making considerable claims on
the Balkans and in respect to the Baltic Sea, and that because of
these claims Hitler was reckoning with the possibility of war. Could
that be correct?</p>
<p class="pindent">LAMMERS: It is possible that we have talked about it, but I
cannot remember for certain.</p>
<p class="pindent">DR. SAUTER: And you know, Dr. Lammers, that in this connection
an organization was established under the heading “Central
Planning?” Do you know that?</p>
<p class="pindent">LAMMERS: Yes.</p>
<p class="pindent">DR. SAUTER: Defendant Funk was also made a member of the
Central Planning, and I think that was at the end of 1943. Is it
correct that Funk, when he joined the Central Planning, was no
longer at all interested in the use of workers for German production,
and why was that so?</p>
<p class="pindent">LAMMERS: I believe that Funk’s only interest in the Central
Planning was to receive raw materials for civilian production.</p>
<p class="pindent">DR. SAUTER: For civilian production at home?</p>
<p class="pindent">LAMMERS: Yes, at home. That was his interest in the Central
Planning, since he was responsible only for the distribution of these
economic goods, and civilian production had been transferred to
Minister Speer.</p>
<p class="pindent">DR. SAUTER: When?</p>
<p class="pindent">LAMMERS: I think that was at the very moment when the Minister
for Armament and Munitions was converted into a Minister for
Armament and War Production. I think that was in 1942. Thus
Funk was, of course, very interested in raw materials; but the employment
of labor, in my opinion, interested him very little, since he
did not have enough raw material at all to allow civilian production
to go on.</p>
<p class="pindent">DR. SAUTER: And then, Dr. Lammers, I have one last question:
Can you remember that Defendant Funk in the year 1944—it is
supposed to have been in February and also a few times during
subsequent months—visited you and told you of his trouble because
of the unsatisfactory position which he was occupying as Minister
of Economics and Plenipotentiary for Economics, and that on this
occasion he talked to you about the question of whether his conscience
would allow him to retain his position as President of the
Reichsbank and Reich Minister of Economics, and, if so, why he did
so and why he did not place this office at the disposal of somebody
else? Perhaps you can say something about this?
<span id="Page_69" title="69"></span></p>
<p class="pindent">LAMMERS: I have frequently discussed these questions with Funk.</p>
<p class="pindent">DR. SAUTER: When?</p>
<p class="pindent">LAMMERS: In 1943, but particularly afterwards in 1944. I know
that he was considerably worried about this and that he wanted
very much to have an opportunity to take his worries to the Führer
personally. If he did remain in office then it was only because he
realized that during wartime he could not resign from his post; that
would not be the right thing for a good German, to resign during
wartime. But he had the most fervent wish to be able to report to
the Führer about the economic situation and mainly about the
particular impressions which the Gauleiter in the individual districts
had. He had the most fervent wish, once for all, to report to the
Führer and learn at least something about the war situation and
talk about the question of ending the war. That was since the beginning
of September. I made several attempts to submit the matter
to the Führer; and I nearly succeeded later by camouflaging the real
reason and pretending there was another important reason, some
question of finance.</p>
<p class="pindent">I submitted the matter to the Führer; but the Führer sized up the
situation, and, although Herr Funk had been waiting at my office
for days for the report, he refused the request, probably because of
Bormann’s efforts towards this end. With the best intentions Funk
did not succeed in seeing the Führer and I did not succeed in taking
him to the Führer.</p>
<p class="pindent">DR. SAUTER: Mr. President, I have otherwise no further question.</p>
<p class="pindent">DR. RUDOLF DIX (Counsel for Defendant Schacht): Mr. President,
if you wish to close the session at 5 o’clock, I must say that I
shall not have finished by 5 o’clock; and I am reluctant to break off
my examination. I leave it up to the Tribunal whether we should
extend the session or whether we should break off now.</p>
<p class="pindent">THE PRESIDENT: I think you had better go on, Dr. Dix; we
have nearly 10 minutes.</p>
<p class="pindent">DR. DIX: Witness, other witnesses and you too—you on the
strength of vast experience and your position as Chief of the Reich
Chancellery from the seizure of power until the collapse—have
stated that applications for resignation were prohibited by Hitler.
I therefore do not want to put any more questions on that subject;
I merely want to discuss the attempts to resign which Schacht
actually made. I ask you first of all to answer the general questions
with “Yes” or “No.”</p>
<p class="pindent">Did Schacht send in applications for resignation or not?</p>
<p class="pindent">LAMMERS: Yes.
<span id="Page_70" title="70"></span></p>
<p class="pindent">DR. DIX: I should now like to discuss with you the individual
applications for resignation. I cannot expect you, without any help,
to recall individual occasions. I permit myself therefore to help your
memory along a little in connection with the first question.</p>
<p class="pindent">Please recall March 1937, when Schacht stopped Reichsbank
credits, that is, gave notice with reference to them and you visited
him in connection with this. Was that the first application for
resignation?</p>
<p class="pindent">LAMMERS: I remember that very exactly, since Herr Schacht’s
application for resignation was very unpleasant for Hitler; and he
gave me the task of straightening the matter out with Schacht. Thus
I made several personal visits to Schacht, but he refused to withdraw
his application for resignation; and he gave, as his reason, the fact
that he could not approve any longer the Führer’s credit policy and
that he was afraid of inflation and would have to protect the German
nation from that. As for the freedom of action, he had to...</p>
<p class="pindent">THE PRESIDENT: Dr. Dix, is it necessary to go into details?
We gather that there are several offers to resign. Is it necessary to
go into the details of each one?</p>
<p class="pindent">DR. DIX: In that case we leave it. It is enough for me, Dr. Lammers,
if you confirm that in March 1937 Schacht made his first application
for resignation.</p>
<p class="pindent">LAMMERS: And then there was a compromise and Herr Schacht,
first of all, was to remain in office 1 more year, although the law
called for a term of 4 years.</p>
<p class="pindent">DR. DIX: Please try to remember what happened further in
August 1937. Göring had issued a decree concerning mines. It was
Schacht’s view that this was an unwarranted interference with
matters under his jurisdiction. Did a second application for resignation
follow?</p>
<p class="pindent">LAMMERS: Yes.</p>
<p class="pindent">DR. DIX: And did not Schacht write a letter on that occasion
addressed to Göring, 5 August, a copy of which he sent to Hitler?
Can you remember that?</p>
<p class="pindent">LAMMERS: Yes. It was because of that letter that Hitler dismissed
Schacht afterwards.</p>
<p class="pindent">DR. DIX: Now we come to the war. Did Schacht also repeat his
applications for resignation during the war? Please recall the
summer of 1941 and a memorandum which Schacht sent to Hitler
regarding the necessity of a speedy conclusion of peace?</p>
<p class="pindent">LAMMERS: The first application for resignation was handed in
because it had been prohibited to listen to foreign broadcasting
stations. Schacht was thereby forbidden to listen to many foreign
<span id="Page_71" title="71"></span>
stations; and he complained about it and handed in an application
for resignation, whether in writing or verbally, I do not know. The
request was refused, and later he submitted a memorandum in which
he discussed the end of the war and the political and economic
situation. I had to tell Schacht, in answer to this memorandum, that
the Führer had read it and had nothing to say in reply. Thereupon,
in 1942, Schacht again asked me to ask the Führer if he was disposed
to receive another memorandum. At this the Führer gave me the
order to write to Schacht and tell him to refrain from submitting any
further memoranda.</p>
<p class="pindent">DR. DIX: I could, Mr. President, recall the important points of
this memorandum of the summer of 1941 for the witness. If the
Tribunal is familiar with the details of this memorandum, which we
do not have and which we could ascertain only on the basis of the
witness’ memory by asking him questions, then I should like to
present to him the exact contents of this memorandum. If on the
other hand the Tribunal is of the opinion...</p>
<p class="pindent">THE PRESIDENT: Have you the memorandum?</p>
<p class="pindent">DR. DIX: No, we do not have the memorandum—only in memory—that
is to say, Schacht remembers it.</p>
<p class="pindent">THE PRESIDENT: If the memorandum is lost and you can prove
the loss, you can put the contents of it to the witness. If the contents
are not relevant it is no good even for the witness. Are the contents
of the document relevant?</p>
<p class="pindent">DR. DIX: These points which I want to submit I do consider
relevant. It is not very long either. It is not long.</p>
<p class="pindent">THE PRESIDENT: So far as the question of proof is concerned,
the rule is, I think, if the document has been lost, you can prove the
contents of it and you can put it to the witness. Yes, you can put
the main points to him, Dr. Dix.</p>
<p class="pindent">DR. DIX: The question which you put to me involves considerable
responsibility. At the moment I can merely assure you that I am
convinced that the memorandum has been lost; but whether I can
prove it, the negative fact that it is lost, that is something I cannot
say at the moment. I am convinced it is lost.</p>
<p class="pindent">THE PRESIDENT: Herr Schacht presumably is going to say it
was lost. You, of course, cannot prove it yourself but I mean you
can prove it by Schacht.</p>
<p class="pindent">DR. DIX: Yes, Schacht will prove it when he becomes a defendant
on the stand.</p>
<p class="pindent">[<span class="it1">Turning to the witness.</span>] This was in September 1941, that is to
say, after the great successes in Russia by the German Army. Then
Schacht wrote in this memorandum to Hitler that Hitler had now
reached the peak of his success and that this was the most favorable
<span id="Page_72" title="72"></span>
moment for him to aim at peace. In the case of any further duration
of the war...</p>
<p class="pindent">MR. DODD: I suggest, would it not be more proper for counsel to
ask this witness, first of all, whether or not he recalls the contents
of the memorandum before reading what purports to be the contents?</p>
<p class="pindent">THE PRESIDENT: I think he should, yes.</p>
<p class="pindent">DR. DIX: I did not remind him of the contents; I just wanted to
recall to him the individual points. Dr. Lammers has already
said that.</p>
<p class="pindent">THE PRESIDENT: I think you had better put it to him sentence
by sentence and not all at once.</p>
<p class="pindent">DR. DIX: But, I am not proposing to read it, Your Honors, I am
merely trying to repeat the contents as Schacht remembers them.
I cannot read it, of course, since I do not know it.</p>
<p class="pindent">THE PRESIDENT: Would you ask the witness if he remembers
what the contents were, not putting it in a leading form.</p>
<p class="pindent">DR. DIX: Yes, I shall certainly ask him. But I think he has
already answered, that he no longer remembers all the details, therefore
I wanted to aid his memory by recalling the main points.</p>
<p class="pindent">THE PRESIDENT: Ask him what he does remember of it.</p>
<p class="pindent">DR. DIX: Well then, Dr. Lammers, without my presenting the
main points to you, what do you remember?</p>
<p class="pindent">LAMMERS: I think that in this memorandum Herr Schacht set
forth the economic capacities of Germany and of foreign countries,
that he pointed out that this period in 1941—I believe it was in the
autumn—was the most favorable moment for peace negotiations, for
bringing the war to an end. He also explained the world situation
but I cannot remember how. He sketched the political situation in
other countries. He talked about America, Italy, Japan, and he
compared the factors. After the Führer had looked at the memorandum
he put it aside and he said, “I have already disapproved of
that; I do not want that.”</p>
<p class="pindent">Further details I do not know.</p>
<p class="pindent">DR. DIX: When you mention “other countries,” do you remember
that he stated that Italy’s withdrawal was merely a question of time,
since the opposition group around the King would not rest until
Mussolini was brought down?</p>
<p class="pindent">LAMMERS: Yes, it is possible that it did say that, but I cannot
remember definitely.</p>
<p class="pindent">THE PRESIDENT: One moment. The Tribunal will adjourn now.</p>
<h3 class="calibre17 sigil_not_in_toc" id="pgepubid00006">[<span class="it1">The Tribunal adjourned until 9 April 1946 at 1000 hours.</span>]</h3>
<div class="calibre2"><span id="Page_73" title="73"></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?4fd35687